var map = {
  "./en-US.ftl": [
    "./l10n/locales/en-US.ftl",
    []
  ],
  "./es.ftl": [
    "./l10n/locales/es.ftl",
    [
      "l10n_locales_es_ftl"
    ]
  ],
  "./de.ftl": [
    "./l10n/locales/de.ftl",
    [
      "l10n_locales_de_ftl"
    ]
  ],
  "./pt-BR.ftl": [
    "./l10n/locales/pt-BR.ftl",
    [
      "l10n_locales_pt-BR_ftl"
    ]
  ],
  "./ja.ftl": [
    "./l10n/locales/ja.ftl",
    [
      "l10n_locales_ja_ftl"
    ]
  ],
  "./zh-TW.ftl": [
    "./l10n/locales/zh-TW.ftl",
    [
      "l10n_locales_zh-TW_ftl"
    ]
  ],
  "./fr.ftl": [
    "./l10n/locales/fr.ftl",
    [
      "l10n_locales_fr_ftl"
    ]
  ],
  "./ru.ftl": [
    "./l10n/locales/ru.ftl",
    [
      "l10n_locales_ru_ftl"
    ]
  ],
  "./zh-CN.ftl": [
    "./l10n/locales/zh-CN.ftl",
    [
      "l10n_locales_zh-CN_ftl"
    ]
  ],
  "./ko.ftl": [
    "./l10n/locales/ko.ftl",
    [
      "l10n_locales_ko_ftl"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "./l10n/locales lazy recursive ^\\.\\/.*\\.ftl$ referencedExports: default";
module.exports = __rspack_async_context;
